// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"afc6a79c","436":"0d0ea6c8","453":"ec2e6140","506":"021108bb","517":"4f05893d","605":"756011af","673":"9b89f8bb","729":"40c3eb5a"}[chunkId] + ".chunk.js";
};